import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

/**
 * Related links grid — connects this page to others (services, cities, blog).
 * Drives internal linking + crawl depth.
 */
export default function RelatedGrid({
  title = "Related",
  items = [],
  testid = "related-grid",
}) {
  if (!items.length) return null;
  return (
    <section data-testid={testid} className="py-14 md:py-20">
      <div className="flex items-center gap-3 mb-8">
        <span className="w-8 h-px bg-[var(--iw-gold)]" />
        <h2
          className="font-serif-display text-[var(--iw-ivory)] text-3xl md:text-4xl leading-tight"
          style={{ fontFamily: "Cormorant Garamond, serif" }}
        >
          {title}
        </h2>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
        {items.map((it) => (
          <Link
            key={it.href}
            to={it.href}
            className="group p-5 md:p-6 transition-all hover:bg-white/5 flex items-start justify-between gap-4"
            style={{
              background: "rgba(255,255,255,0.02)",
              border: "1px solid rgba(212,175,55,0.18)",
            }}
            data-testid={`${testid}-link-${it.href.replace(/\//g, "-")}`}
          >
            <div className="flex-1 min-w-0">
              {it.eyebrow && (
                <span className="overline text-[var(--iw-gold)] block mb-1.5 text-[10px]">
                  {it.eyebrow}
                </span>
              )}
              <h3
                className="font-serif-display text-[var(--iw-ivory)] text-xl md:text-2xl leading-tight group-hover:text-[var(--iw-gold)] transition-colors"
                style={{ fontFamily: "Cormorant Garamond, serif" }}
              >
                {it.label}
              </h3>
              {it.description && (
                <p className="text-[var(--iw-muted)] text-sm leading-relaxed mt-2">
                  {it.description}
                </p>
              )}
            </div>
            <ArrowUpRight
              size={16}
              className="text-[var(--iw-faint)] group-hover:text-[var(--iw-gold)] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all shrink-0 mt-1"
            />
          </Link>
        ))}
      </div>
    </section>
  );
}
